const isLocal = () => window.location.protocol === 'file:'

export default isLocal
